import loader from './lib/loader';

import(/* webpackPrefetch: true */ './icons');
// loader('sheperd', 'body.tool');
import('./tooltip').then((module) => module.default());
import('./popup').then((module) => module.default());
loader('menu', '#nav-icon');
loader('tabs', '.nav-tabs');
loader('quickAction', '.quick-action');
loader('popover', '[data-toggle="popover"]');
loader('compareModal', '#modal-compare');
loader('videoModal', '.videoContainer');
loader('tipsModal', '#myTips');
loader('planner', '#svelte-planner');
loader('popupAccordion', '.popup-accordion');
loader('formRepeater', '.popup-form__repeater');
loader('dateInput', '.popup-form__date');
loader('dateRange', '.time-range');
loader('foldAccordion', '.fold-item');
loader('faq', '.faq');
loader('scoreChanger', '.tool-score__score');
loader('toolResult', '.tool-steps');
